export const getBase64 = (
  file: File,
  stripMetadata = false
): Promise<string | null> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      const result = reader.result as string | null
      if (stripMetadata && result) {
        resolve(result.split(',')[1] ?? null)
      } else {
        resolve(result)
      }
    }
    reader.onerror = (error) => reject(error)
  })

export const resolveUrl = (
  filename?: string | null,
  omitSeparator?: boolean
) => {
  const separator = omitSeparator ? '' : '/'
  return filename ? `${window.location.origin}${separator}${filename}` : ''
}

export const getFileNameFromUrl = (urlString: string) => {
  const url = new URL(urlString)
  const pathname = url.pathname // ruta sin parámetros
  const fileName = pathname.split('/').pop() // último segmento

  if (!fileName) throw new Error('No file name found in the provided URL')

  // Manejo de nombres con múltiples puntos
  const lastDot = fileName.lastIndexOf('.')
  if (lastDot === -1) {
    return fileName // sin extensión
  }

  const name = fileName.substring(0, lastDot)
  const extension = fileName.substring(lastDot + 1)

  return `${name}.${extension}`
}

export const getFileExtension = (file: File) =>
  file.name.split('.').pop() || file.type.split('/').pop() || '?'

export const base64ToBlobUrl = ({
  pdfBase64,
  contentType
}: {
  pdfBase64: string
  contentType: string
}) => {
  const bytes = Uint8Array.from(atob(pdfBase64), (c) => c.charCodeAt(0))
  const blob = new Blob([bytes], { type: contentType })
  return URL.createObjectURL(blob)
}
